import { render, staticRenderFns } from "./MainStationComponent.vue?vue&type=template&id=25b96fb5&scoped=true&"
import script from "./MainStationComponent.vue?vue&type=script&lang=js&"
export * from "./MainStationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b96fb5",
  null
  
)

export default component.exports